/** biome-ignore-all lint/complexity/noExcessiveCognitiveComplexity: TODO */

import { useVisitorData } from '@fingerprint/react';
import { useQueryEvents } from '@homestake/shared/hooks';
import { batch } from '@legendapp/state';
import Clarity from '@microsoft/clarity';
import { useQuery } from '@tanstack/react-query';
import Decimal from 'decimal.js';
import { getApiGameInit } from '../api';
import { getApiGameInitQueryKey } from '../api/__generated__/@tanstack/react-query.gen';
import {
  autoBetState$,
  gameState$,
  manualBetState$,
  towersState$,
} from '../state';
import { configurationState$ } from '../state/configuration.state';
import { freeBetState$ } from '../state/free-bet.state';
import { type SessionStatus, sessionState$ } from '../state/session.state';
import { walletState$ } from '../state/wallet.state';

console.log('a');

export const useInitGame = (token: string | undefined | null) => {
  const { getData } = useVisitorData({ immediate: false });

  const query = useQuery({
    queryFn: async ({ signal }) => {
      const { visitor_id } = await getData();

      if (!visitor_id) {
        throw new Error('Failed to load visitor id.');
      }

      const { data } = await getApiGameInit({
        query: {
          Token: token ?? '',
          VisitorId: visitor_id,
        },
        signal,
        throwOnError: true,
      });

      return data;
    },
    queryKey: getApiGameInitQueryKey({
      query: { Token: token ?? '', VisitorId: '' },
    }),
    enabled: Boolean(token),
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  useQueryEvents(query, {
    onSuccess: ({
      balance,
      coeficient,
      currency,
      currencyExchange,
      currencyType,
      gameRoundId,
      maxBet,
      maxWin,
      minBet,
      pattern,
      status,
      towersResults,
      bets,
      betStep,
      defaultBet,
      baseBonusResponseDto,
    }) => {
      Clarity.identify(token ?? '');
      batch(() => {
        const hasFreeBets =
          baseBonusResponseDto?.isActive === true &&
          baseBonusResponseDto.bonusCount > 0;

        const isRunningManualBet = towersResults && towersResults.length > 0;
        const calculatedMinBet = new Decimal(minBet ?? 0)
          .div(coeficient)
          .toNumber();
        const calculatedMaxBet = new Decimal(maxBet).div(coeficient).toNumber();
        const calculatedMaxWin = new Decimal(maxWin).div(coeficient).toNumber();

        const calculatedBetAmount = new Decimal(
          hasFreeBets ? baseBonusResponseDto.bonusAmount : defaultBet
        )
          .clamp(minBet, maxBet)
          .div(coeficient)
          .toNumber();

        const calculatedBetStep = betStep
          ? new Decimal(betStep).div(coeficient).toNumber()
          : null;
        if (pattern !== undefined && pattern !== null) {
          gameState$.pattern.set(pattern);
          manualBetState$.setIsBetting(true);
        }
        configurationState$.assign({
          coeficient,
          currency: currency ?? '',
          currencyType: currencyType ?? '',
          currencyExchangeRate: currencyExchange,
          maxBet: calculatedMaxBet,
          maxWin: calculatedMaxWin,
          minBet: calculatedMinBet,
          predefinedBets: bets,
          betStepAmount: calculatedBetStep ?? 0,
        });
        sessionState$.assign({
          gameRoundId: gameRoundId ?? '',
          status: status as SessionStatus,
        });
        towersState$.setAllBricks(towersResults ?? []);
        walletState$.setBalance(balance);
        autoBetState$.betAmount.set(calculatedBetAmount);
        manualBetState$.betAmount.set(calculatedBetAmount);
        if (isRunningManualBet) {
          manualBetState$.setIsBetting(true);
        }

        if (baseBonusResponseDto) {
          freeBetState$.initialize(baseBonusResponseDto);
        }
      });
    },
    // TODO: handle error
  });

  return query;
};
